import toastr from 'toastr';

function defaultToast(
	text = '',
	type = 'success',
	position = 'toast-top-right',
	redirect = '',
	useProgressBar = false
) {
	toastr.options = {
		closeButton: false,
		debug: false,
		newestOnTop: false,
		progressBar: useProgressBar,
		positionClass: position,
		preventDuplicates: false,
		// onclick: null,
		showDuration: 300,
		hideDuration: 1000,
		timeOut: 5000,
		extendedTimeOut: 1000,
		showEasing: 'swing',
		hideEasing: 'linear',
		showMethod: 'fadeIn',
		hideMethod: 'fadeOut',
		onHidden: function () {
			if (redirect) {
				window.location.href = redirect;
			}
		},
	};

	if (type === 'error') {
		toastr.error(text);
	} else if (type === 'warning') {
		toastr.warning(text);
	} else {
		toastr.success(text);
	}
}

export default defaultToast;
